import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20golden%20and%20deep%20red%20composition%20inspired%20by%20Chinese%20culture%20and%20traditional%20games%2C%20smooth%20flowing%20shapes%2C%20soft%20gradient%20textures%2C%20elegant%20warm%20atmosphere%2C%20modern%20minimalist%20design%20with%20luxurious%20feel%2C%20no%20text%2C%20dark%20rich%20crimson%20and%20amber%20tones%2C%20perfect%20hero%20background&width=1920&height=900&seq=hero-mahjong-main&orientation=landscape"
        alt="麻将游戏在线玩 - 免费经典麻将平台"
        title="麻将游戏在线玩 - 免费经典麻将，随时随地畅玩"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 text-center leading-tight max-w-4xl">
          免费经典麻将
          <span className="block text-accent-400 mt-2">随时随地畅玩</span>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-50/80 text-center max-w-2xl leading-relaxed">
          多种麻将玩法随心选，无需下载即开即玩。支持电脑与手机，新手老手皆宜，
          随时随地享受正宗麻将对战乐趣
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-6 md:mt-8">
          <Link
            to="/categories"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/30"
          >
            立即开始游戏
          </Link>
          <Link
            to="/articles"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-8 py-3 border border-background-50/40 text-background-50 font-medium rounded-full text-sm md:text-base hover:bg-background-50/15 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看游戏攻略
          </Link>
        </div>

        <div className="flex items-center gap-6 md:gap-10 mt-8 md:mt-12">
          {[
            { value: '500万+', label: '累计玩家' },
            { value: '12种', label: '麻将玩法' },
            { value: '4.8分', label: '用户评分' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-3xl font-heading text-accent-400">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}